/**
 * 根据不同的来源使用不同的请求
 */
// 对应`/auction/carInfo/edit`路由
export const edit = {
  getCarInfo: {
    inquiry: id => `used_car/ticket/car_info/${id}/meta`,
    auction: id => `auctions/car_infos/${id}`
  },
  saveCarInfo: {
    inquiry: id => `used_car/ticket/car_info/${id}/status`,
    auction: id => `auctions/car_infos/${id}`
  }
}
export const detail = {
  getClueDetail: { // 获取线索评估详情
    inquiry: id => `used_car/ticket/car_info/${id}`,
    auction: id => `auctions/car_infos/${id}/details`
  }
}
export const basic = {
  saveBasicInfo: { // 编辑基本信息
    inquiry: id => `used_car/ticket/car_info/${id}`,
    auction: id => `auctions/car_infos/${id}/details`
  }
}
export const config = {
  saveConfig: { // 编辑车辆详情
    inquiry: id => `used_car/ticket/car_info/${id}/info`,
    auction: id => `auctions/car_infos/${id}/info`
  }
}
export const procedure = {
  saveProcedure: { // 编辑车辆详情
    inquiry: id => `used_car/ticket/car_info/${id}/info`,
    auction: id => `auctions/car_infos/${id}/info`
  }
}
export const remark = {
  saveRemark: { // 编辑车辆详情
    inquiry: id => `used_car/ticket/car_info/${id}/remark`,
    auction: id => `auctions/car_infos/${id}/remark`
  }
}
export const photo = {
  inquiry: id => `used_car/ticket/car_info/${id}/images`,
  auction: id => `auctions/car_infos/${id}/images`
}

export const inspection = {
  getInspectionsInfo: { // 获取车辆检测信息
    inquiry: id => `used_car/ticket/car_info/${id}/inspection`,
    auction: id => `auctions/car_infos/${id}/inspection`
  },
  saveInspectionsInfo: { // 保存车辆检测信息
    inquiry: id => `used_car/ticket/car_info/${id}/inspection`,
    auction: id => `auctions/car_infos/${id}/inspection`
  }
}
export const evaluate = {
  inquiry: id => `used_car/ticket/car_info/${id}/overview`,
  auction: id => `auctions/car_infos/${id}/overview`
}
